import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1acb3c99 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _bec0b0b2 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _3db6e4b2 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _1fe6e684 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _46e8c980 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _b59c8192 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _d8114d7a = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _56225b39 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _f5adfbee = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _66b86302 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _4f6163b4 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _5f6e1134 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _c80ca842 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _f9d53894 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _7198b76e = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _3c133d0c = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _086fd624 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _322892e9 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _5c50c544 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _558b75be = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _1acb3c99,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _bec0b0b2,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _3db6e4b2,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _1fe6e684,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _46e8c980,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _b59c8192,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _b59c8192,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _b59c8192,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _d8114d7a,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _56225b39,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _f5adfbee,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _56225b39,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _f5adfbee,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _66b86302,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _66b86302,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _66b86302,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _66b86302,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _66b86302,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _66b86302,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _66b86302,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _4f6163b4,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _4f6163b4,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _5f6e1134,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _c80ca842,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _c80ca842,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _f9d53894,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _7198b76e,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _3c133d0c,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _3c133d0c,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _086fd624,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _322892e9,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _5c50c544,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _558b75be,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
